import axios from 'axios';
import { Debugger } from '../utils/index';
import { Socket } from '../services/phoenix';

const apiUrl = '/api';

class Api {
  /**
   *
   * GRID AREAS
   *
   */
  getAllGridAreas() {
    return axios.get(`${apiUrl}/grid_areas`);
  }

  postGridArea(payload) {
    return axios.post(`${apiUrl}/grid_areas`, payload);
  }

  /**
   *
   * ENDPOINTS
   *
   */
  postEndpoint(payload) {
    return axios.post(`${apiUrl}/endpoints`, payload);
  }

  getAllEndpoints() {
    return axios.get(`${apiUrl}/endpoints`);
  }

  getEndpointsByGridAreaId(gridAreaId) {
    return axios.get(`${apiUrl}/endpoints/by_grid_area/${gridAreaId}`);
  }

  getAffectedEndpointsByEndpointId(endpointId) {
    return axios.get(`${apiUrl}/endpoints/affected/${endpointId}`);
  }

  getEndpointDetails(endpointId) {
    return axios.get(`${apiUrl}/endpoints/details/${endpointId}`);
  }

  /**
   *
   * DEVICES
   *
   */
  getAllDevices() {
    return axios.get(`${apiUrl}/devices`);
  }

  getDevicesByGridAreaId(gridAreaId) {
    return axios.get(`${apiUrl}/devices/${gridAreaId}`);
  }

  postDevice(payload) {
    return axios.post(`${apiUrl}/devices`, payload);
  }

  /**
   *
   * EVENTS
   *
   */
  getAllEvents() {
    return axios.get(`${apiUrl}/events`);
  }

  getAllEventsByEndpointId(endpointId) {
    return axios.get(`${apiUrl}/events/endpoint_all/${endpointId}`);
  }

  getUnresolvedEvents() {
    return axios.get(`${apiUrl}/events/unresolved/all`);
  }

  resolveAllEvents() {
    return axios.put(`${apiUrl}/events/resolve/all`);
  }

  resolveAllEventsByEndpointId(endpointId) {
    return axios.put(`${apiUrl}/events/resolve/endpoint/${endpointId}`);
  }

  resolveEventByEventId(eventId) {
    return axios.put(`${apiUrl}/events/${eventId}`, {
      event: {
        resolved: true,
      },
    });
  }

  eventWebsocketConnection() {
    const socket = new Socket('/socket');
    socket.connect();

    const events = socket.channel('events:all');
    events.on('new_event', (msg) => {
      Debugger.log('Got events message', msg);
    });

    events.join().receive('ok', ({ messages }) => Debugger.log('catching up', messages))
      .receive('error', ({ reason }) => Debugger.log('failed join', reason))
      .receive('timeout', () => Debugger.log('Networking issue. Still waiting...'));

    socket.onError(() => Debugger.log('there was an error with the connection!'));
    socket.onClose(() => Debugger.log('the connection dropped'));

    events.onError(() => Debugger.log('there was an error!'));
    events.onClose(() => Debugger.log('the channel has gone away gracefully'));

    return events;
  }

  /**
   *
   * STATS
   *
   */
  getNumberOfEvents() {
    return axios.get(`${apiUrl}/stats/event_count`);
  }

  getNumberOfResolvedEvents() {
    return axios.get(`${apiUrl}/stats/event_count_resolved`);
  }

  getNumberOfUnresolvedEvents() {
    return axios.get(`${apiUrl}/stats/event_count_unresolved`);
  }

  getEndpointTypeCount(endpointId) {
    return axios.get(`${apiUrl}/stats/endpoint/child/${endpointId}`);
  }
}

export default new Api();
